"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstComment = void 0;
const sortMessages_1 = require("./sortMessages");
function getFirstComment(item) {
    try {
        const messages = (0, sortMessages_1.sortMessages)((item === null || item === void 0 ? void 0 : item.messages) || []);
        return messages.length > 0 ? messages[0] : undefined;
    }
    catch (_a) { }
}
exports.getFirstComment = getFirstComment;
exports.default = getFirstComment;
